import "./style.css";

export default function IndicatorsBand({
  title = "Nossos indicadores",
  imageUrl,
  indicators = [],
  decoration,
  compact = false,
  showOverlay = true,
  className = "",
}) {
  if (!indicators.length) return null;

  return (
    <section
      className={`indicators-band ${compact ? "indicators-band--compact" : ""} ${className}`.trim()}
      style={imageUrl ? { backgroundImage: `url(${imageUrl})` } : {}}
    >
      {showOverlay && <div className="indicators-band__overlay" />}

      {decoration && (
        <div className="indicators-band__decoration" aria-hidden="true">
          {decoration}
        </div>
      )}

      <div className="indicators-band__content">
        <h2 className="indicators-band__title">{title}</h2>

        <div className="indicators-band__list">
          {indicators.map((item, index) => (
            <div
              key={item.id || item._id || `${item.value}-${index}`}
              className={`indicators-band__item ${
                index === 1 ? "indicators-band__item--highlight" : ""
              }`}
            >
              <strong>{item.value}</strong>
              <span>{item.label}</span>
              {item.description && (
                <small className="indicators-band__description">
                  {item.description}
                </small>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
